/*
 * Ausverkauft-Zustand (snippets/kik-ausverkauft.liquid). Impact ersetzt den Block bei jedem Variantenwechsel, eine
 * aria-live-Region darin würde nie angesagt. Deshalb:
 * 1. Eine dauerhafte, unsichtbare Live-Region am Ende von <body>. Sobald ein neuer Ausverkauft-Block erscheint
 *    (MutationObserver), wird sein data-ansage dort hineingeschrieben, z. B. „Größe M ausverkauft. Verfügbar in: S, L.“
 * 2. Die Größen-Knöpfe „Verfügbar in“ wählen die Größe in Impacts Varianten-Auswahl (Radio mit der ID des Optionswerts),
 *    der Fokus geht auf diese Auswahl, Impact stellt ihn nach dem Neuaufbau wieder her.
 */
(() => {
  let region = null;

  const ansagen = (text) => {
    if (!text) return;
    if (!region) {
      region = document.createElement('div');
      region.className = 'sr-only';
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('role', 'status');
      document.body.appendChild(region);
    }
    region.textContent = '';
    // kurze Pause, damit Screenreader auch denselben Text erneut ansagen
    window.setTimeout(() => { region.textContent = text; }, 120);
  };

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        const block = node.matches('[data-kik-ausverkauft]') ? node : node.querySelector('[data-kik-ausverkauft]');
        // Nur nach einem Wechsel ansagen, nicht beim ersten Laden der Seite
        if (block && document.readyState === 'complete') ansagen(block.dataset.ansage);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-kik-option-wert]');
    if (!chip) return;

    const form = chip.dataset.kikForm;
    const input = [...document.querySelectorAll(`input[type="radio"][value="${CSS.escape(chip.dataset.kikOptionWert)}"]`)]
      .find((el) => el.getAttribute('form') === form || el.closest('form')?.id === form);
    if (!input) return;

    input.focus({ preventScroll: true });
    input.click();
  });
})();
